import React from 'react';
import ServicePageTemplate from '../components/ServicePageTemplate';
import { CreditCard } from 'lucide-react';

const CreditCardPage = () => (
  <ServicePageTemplate
    translationPrefix="creditCardPage"
    icon={CreditCard}
    color="from-red-500 to-red-600"
    accentColor="bg-red-50 border border-red-200"
  />
);

export default CreditCardPage;
